
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-40 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M161 512h191c44.113 0 80-35.887 80-80V161c0-44.113-35.887-80-80-80H161c-44.113 0-80 35.887-80 80v271c0 44.113 35.887 80 80 80zm191-391c22.055 0 40 17.945 40 40v271c0 22.055-17.945 40-40 40H161c-22.055 0-40-17.945-40-40V161c0-22.055 17.945-40 40-40zM1 382V80C1 35.887 36.887 0 81 0h222c11.047 0 20 8.953 20 20s-8.953 20-20 20H81c-22.055 0-40 17.945-40 40v302c0 11.047-8.953 20-20 20s-20-8.953-20-20zm0 0"}})])
          )
        }
      }
    